import { pipe } from "fp-ts/function";
import * as L from "monocle-ts/Lens";
import { UIState } from "controllers/UIStateCollector/models/UIStateModel";

export const LuciferPageL = pipe(L.id<UIState>(), L.prop("luciferPage"));
